import React from 'react';
import Label from "../../Label/Label";

var FeedbackModalSubtitle = function FeedbackModalSubtitle(_ref) {
  var visible = _ref.visible,
      required = _ref.required,
      text = _ref.text,
      labelClassNames = _ref.labelClassNames;

  if (!visible) {
    return null;
  }

  var labelClass = "mb-2 fw-bold ".concat(labelClassNames);
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement("span", {
    className: labelClass
  }, text, required && /*#__PURE__*/React.createElement("span", {
    className: "text-danger ps-1"
  }, "*"))));
};

FeedbackModalSubtitle.displayName = "FeedbackModalSubtitle";
export default FeedbackModalSubtitle;